import React from 'react';

import { Route, Redirect } from 'react-router';
import MainContainer from 'components/layouts/main.container';
import AppRoutes from 'components/app.routes';
import NotFound from 'components/notFound';

const {
  LabelViewerRoute,
  ClassifierRoute,
  EntityRecommenderRoute
} = AppRoutes;

export default (
  <Route path='/' component={MainContainer}>
    { LabelViewerRoute }
    { ClassifierRoute }
    { EntityRecommenderRoute }
    <Route path='/404' component={NotFound} />
    <Redirect from='*' to='/404' />
  </Route>
)



// WEBPACK FOOTER //
// ./src/routes/index.jsx